export function buildPagination({ 
  data, perPage = 25, 
  totalItemsField = 'total',
  nextPageField = 'next_page',
  prevPageField = 'prev_page',
  totalPagesField = 'total_pages',
  currentPageField = 'current_page',
}) {
  return {
    perPage,
    currentPage: data[currentPageField],
    totalItems: data[totalItemsField],
    nextPage: data[nextPageField] ? data[currentPageField] + 1 : null,
    prevPage: data[currentPageField] === 1 ? null : data[currentPageField] - 1,
    totalPages: data[totalPagesField],
  }
}